import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class Brand extends BaseEntity{
    
    brandCode : string;
    name : string;
    rank : number;
    
}